import src from "IMAGE";
export default { src, width: 1303, height: 193, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AGdnZ2Fubm5nWVlZVHFxcWtmZmZgcnJya1xcXFZnZ2dh0wgMuCaLlgUAAAAASUVORK5CYII="};
